import { gql } from '@apollo/client';

export const WATCH_FUTURE_TRANSFERS = gql`
  mutation WatchFutureTransfer($chain: Chain!) {
    watchFutureTransfer(chain: $chain)
  }
`;
